import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PROFILE } from 'service/api';
import { QUERY_KEYS } from './queryKey';

const profileQueryKey = [QUERY_KEYS.PROFILE];
const authProfileQueryKey = [QUERY_KEYS.AUTH_PROFILE];

export const useAuthProfile = () =>
  useQuery({
    queryKey: authProfileQueryKey,
    queryFn: () => PROFILE.fetchProfile(),
    staleTime: 5 * 60 * 1000,
    select: (response) => {
      const result = response?.data?.data?.data ?? response?.data?.data ?? response?.data;
      const profile = result?.owner ?? result?.user ?? result?.profile ?? result;
      if (!profile || typeof profile !== 'object' || Array.isArray(profile)) {
        throw new Error('The profile API returned an unexpected response.');
      }
      return profile;
    }
  });

export const useGymProfile = () =>
  useQuery({
    queryKey: profileQueryKey,
    queryFn: () => PROFILE.fetchGymProfile(),
    staleTime: 5 * 60 * 1000,
    select: (response) => {
      const result = response?.data?.data?.data ?? response?.data?.data ?? response?.data;
      const profile = result?.gym && result?.owner ? result : result?.profile;
      if (!profile?.gym || !profile?.owner) {
        throw new Error('The gym profile API returned an unexpected response.');
      }
      return profile;
    }
  });

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData) => PROFILE.updateProfile(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileQueryKey });
      queryClient.invalidateQueries({ queryKey: authProfileQueryKey });
    }
  });
};
